import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  field: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  coupledFields: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
  },
  coupledField: {
    width: '45%',
  },
  saveButton: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  errorMessage: {
    width: 350,
    marginTop: theme.spacing(2),
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/CreditCardModal/useStyles.js